export default "__VITE_ASSET__BbCr2phQ__"